import * as types from './types'
import storage from '@/plugins/storage'
const cleanVehicle = {
  Id: 0,
  VIN: '',
  Year: 0,
  Odometer: 0,
  VRM: '',
  Make: {
    Id: 0,
    Text: ''
  },
  Model: {
    Id: 0,
    Text: ''
  },
  Submodel: {
    Id: 0,
    Text: ''
  },
  Engine: {
    Id: 0,
    Liter: '',
    CID: '',
    Cylinders: '',
    BlockType: ''
  },
  DriveType: {
    Id: 0,
    Text: ''
  },
  OdometerUnits: {
    Id: 0,
    Text: ''
  },
  Transmission: {
    Id: 0,
    Text: ''
  },
  Insurance: {
    Id: 0,
    Text: ''
  }
}
const cleanRequest = {
  Id: 0,
  RONumber: '',
  IsMil: null,
  IsSRS: null,
  IsDrivable: null,
  ShopComments: '',
  Contact: {
    Id: 0,
    Username: '',
    GivenName: '',
    FamilyName: '',
    PhoneNumber: '',
    Email: ''
  },
  Location: {
    Id: 0,
    Name: ''
  },
  Device: {
    Id: 0,
    FriendlyName: '',
    SerialNumber: '',
    DeviceTypeId: 0,
    DeviceTypeName: '',
  },
  ScanType: {
    Id: 0,
    Name: ''
  },
  ServiceElement: {
    Id: 0,
    Name: ''
  },
  ScheduleDates: [],
  Vehicle: JSON.parse(JSON.stringify(cleanVehicle)),
  CreatedBy: 0,
  CreatedDate: null,
  UpdatedBy: 0,
  UpdatedDate: null,
  AppId: 1,
  CalibrationSetup: '',
  WindscreenReplaced: -1,
  CalibrationAttempted: -1
}

export default {
  pageSize: 10,
  searchTerm: '',
  sortDir: 'desc',
  orderBy: 'Id',
  filterBy: null,
  totalCount: 0,
  cleanRequest,
  cleanVehicle,
  requests: [],
  request: JSON.parse(JSON.stringify(cleanRequest)),
  requestCount: {
    pending: 0,
    inprocess: 0,
    scheduled: 0,
    completed: 0
  },
  vinSummary: null,
  newVehicle: JSON.parse(JSON.stringify(cleanVehicle)),
  years: [],
  makes: [],
  models: [],
  jatoMakes: [{ value: -1, name: 'Vin Mismatch' }],
  jatoModels: [{ value: -1, name: 'Vin Mismatch' }],
  jatoYears: [],
  jatoMakeSelected: { id: null, value: null },
  jatoModelSelected: { id: null, value: null },
  submodels: [],
  engines: [],
  transmissions: [],
  drivetypes: [],
  id: '',
  scantypes: [], // JSON.parse(storage.local.getItem(types.SESSION_SCANTYPES)) || [],
  serviceelements: [], // JSON.parse(storage.local.getItem(types.SESSION_SERVICEELEMENTS)) || [],
  ragratingvehicleid: '',
  statuslist: [],
  decodeError: '',
  totalUnreadChats: 0,
  requestUnreadReset: 0,
  requestUnreadCount: null,
  requestUnreadById: {},
  requestUnread: 0,
  noRequest: false,
  mahleApiErrorMsg: storage.local.getItem(types.SESSION_MAHLE_API_ERROR_MSG),
  ragServiceElements: [],
  ragDeviceTypes: []
}
